var map = {
	"./white-b-case-closed-xbox.svg": "3bec",
	"./white-b-disc-b-case-opened.svg": "6e69",
	"./white-b-disc-w-case-closed.svg": "5ae5",
	"./white-b-disc-w-case-opened-xbox.svg": "f919",
	"./white-w-case-closed-xbox.svg": "f40c",
	"./white-w-disc-b-case-closed.svg": "ab97",
	"./white-w-disc-b-case-opened.svg": "3a15",
	"./white-w-disc-w-case-closed.svg": "76f8",
	"./white-w-disc-w-case-opened-xbox.svg": "9445",
	"./white-w-disc-w-case-opened.svg": "90a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6087";